<template>
    <v-container class="text-xs-center"> 
        <v-layout row wrap justify-center>
            <v-flex xs12 md10>
                <v-btn @click="isDesktop=!isDesktop" style="position:fixed; top:60px; right:27px;">{{isDesktop?'Vista semplificata':'Vista calendario'}}</v-btn><br>
                <div id="ec" v-show="isDesktop"></div>
                <div v-show="!isDesktop">
                    <div v-for="appointment in shownListAppointments" :key="appointment.resourceId" :style="'margin-bottom:10px;background:'+appointment.color"
                        @click="selectedAppointment=appointments.filter(a => a.resourceId == appointment.resourceId)[0];showInfoDialog=true;">
                        
                        <strong>Da</strong> {{ appointment.start | datetime }} &nbsp;&nbsp;<strong>A </strong>{{ appointment.end | datetime }} <br>
                        {{ appointment.title }}<br>
                        <Pet v-if="appointment.petId" :petId="appointment.petId"></Pet>
                    </div>
                    <span v-if="shownListAppointments.length == 0">Nessun appuntamento futuro!</span>
                </div>
            </v-flex>
        </v-layout>
        <v-btn
            color="green"
            v-if="!isLoading || !isDesktop"
            dark
            absolute
            bottom
            right
            fab
            @click.native="showCreationDialog=true;"
            style="bottom:20px;font-size:40px;"
            > +
        </v-btn>
        <v-dialog
            v-model="showCreationDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Crea appuntamento
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="newAppointment.fromDate"
                        type="date"
                        label="Data di inizio"
                        required
                    ></v-text-field>
                     <v-text-field
                        v-model="newAppointment.fromTime"
                        type="time"
                        label="Ora di inizio"
                        required
                    ></v-text-field>
                    <br><strong>Servizio</strong><br>
                    <SelectService v-model="newAppointment.service"/>
                    <div v-if="[11,12,13].includes(newAppointment.service)">
                        <v-switch
                            v-model="newAppointment.addVisit"
                            :label="`Aggiungo anche una visita subito dopo`"
                        ></v-switch>
                    </div>
                    <div v-if="[4].includes(newAppointment.service)">
                        <v-switch
                            v-model="newAppointment.addAsiloOut"
                            :label="`Aggiungo anche un altro evento asilo uscita`"
                        ></v-switch>
                        <v-switch
                            v-model="newAppointment.addToelettatura"
                            :label="`Aggiungo anche una bagno+toelettatura all'uscita`"
                        ></v-switch>
                        
                        <v-text-field
                            v-model="newAppointment.addFromDate"
                            v-if="newAppointment.addAsiloOut || newAppointment.addToelettatura"
                            type="date"
                            label="Data di uscita"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="newAppointment.addFromTime"
                            v-if="newAppointment.addAsiloOut || newAppointment.addToelettatura"
                            type="time"
                            label="Ora di uscita"
                            required
                        ></v-text-field>
                    </div>

                    <div v-if="[10].includes(newAppointment.service)">
                        <v-switch
                            v-model="newAppointment.addPensioneOut"
                            :label="`Aggiungo anche un altro evento pensione uscita`"
                        ></v-switch>
                        <v-switch
                            v-model="newAppointment.addToelettatura"
                            :label="`Aggiungo anche bagno+toelettatura all'uscita`"
                        ></v-switch>
                        
                        <v-text-field
                            v-model="newAppointment.addFromDate"
                            v-if="newAppointment.addPensioneOut || newAppointment.addToelettatura"
                            type="date"
                            label="Data di uscita"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="newAppointment.addFromTime"
                            v-if="newAppointment.addPensioneOut || newAppointment.addToelettatura"
                            type="time"
                            label="Ora di uscita"
                            required
                        ></v-text-field>
                    </div>
                    <br><strong>Cliente</strong>
                    <SelectCustomer v-model="newAppointment.customer"/>
                    <br><strong>Animale</strong>
                    <SelectPet :customerId="newAppointment.customer" v-model="newAppointment.pet" v-if="newAppointment.customer"/>
                    <span style="font-style:italic" v-else><br>Selezionare cliente...<br><br></span>
                    
                    <br><strong>Note</strong>
                    <v-text-field
                        v-model="newAppointment.title"
                        placeholder="Note sull'appuntamento..."
                    ></v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showCreationDialog = false"
                >
                    Annulla
                </v-btn>
                <v-btn
                    color="green"
                    style="color:white"
                    text
                    @click="
                        createAppointment(newAppointment.service, newAppointment.customer, newAppointment.fromDate, newAppointment.fromTime);
                        showCreationDialog = false;
                    "
                >
                    Crea
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="showInfoDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Appuntamento {{selectedAppointment.resourceId}}
                </v-card-title>
                <v-card-text>
                    <h3>{{selectedAppointment.title}}</h3><br>
                    <strong>Inizio</strong> {{selectedAppointment.start|datetime}}<br>
                    <strong>Fine</strong> {{selectedAppointment.end|datetime}}</span><br>
                    <strong>Durata</strong> {{(new Date(selectedAppointment.end)-new Date(selectedAppointment.start))/1000/60}} minuti<br><br>
                    <v-text-field
                        v-model="appointmentNewDate"
                        v-if="showChangeAppointmentDate"
                        type="date"
                        label="Nuova data di inizio"
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="appointmentNewTime"
                        v-if="showChangeAppointmentDate"
                        type="time"
                        label="Nuova ora di inizio"
                        required
                    ></v-text-field>
                    <span style="display: none;">{{appointmentNewTime}}</span>
                    <span 
                        v-if="showChangeAppointmentDate"
                    >
                        <strong >Nuova fine</strong> {{computedNewEnd|datetime}}<br><br>
                    </span>
                    <v-btn v-show="!showChangeAppointmentDate" style="margin-left:0" @click="function(){computeNewDatetime(selectedAppointment.start);showChangeAppointmentDate=true}">
                        <i aria-hidden="true" class="v-icon material-icons theme--light">edit_calendar</i> &nbsp;
                        Sposta appuntamento
                    </v-btn> 
                    <v-btn v-show="!showChangeAppointmentDate" style="margin-left:0;background:red;color:white;" @click="function(){deleteAppointment(selectedAppointment.resourceId);showInfoDialog=false;}">
                        <i aria-hidden="true" class="v-icon material-icons theme--light">edit_calendar</i> &nbsp;
                        Elimina appuntamento
                    </v-btn>
                    <v-btn v-show="showChangeAppointmentDate" style="margin-left:0;background:green;color:white;" @click="function(){showChangeAppointmentDate=false;showInfoDialog=false;saveNewDate(selectedAppointment.resourceId, appointmentNewDate, appointmentNewTime)}">
                        <i aria-hidden="true" class="v-icon material-icons theme--light">edit_calendar</i> &nbsp;
                        Salva nuova data
                    </v-btn><br><br>
                    <div v-if="selectedAppointmentCustomer">
                        <strong>Nome cliente</strong> {{selectedAppointmentCustomer.name}} {{selectedAppointmentCustomer.lastname}}<br>
                        <strong>Tel.</strong> {{selectedAppointmentCustomer.telephone}}<br>
                        <strong>Cell.</strong> {{selectedAppointmentCustomer.mobilePhone}}<br><br>
                        <v-btn style="margin-left:0" @click="function(){$router.push({name:'customer',params:{customerId:selectedAppointmentCustomer.id}})}">
                            <i aria-hidden="true" class="v-icon material-icons theme--light">contact_page</i> &nbsp;
                            Scheda cliente
                        </v-btn>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showInfoDialog = false; showChangeAppointmentDate=false"
                >
                    Chiudi
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="showDeletedToast">
            Appuntamento eliminato!
        </v-snackbar>
    </v-container>
</template>

<script>
const axios = require('axios').default;
import '@event-calendar/core/index.css';

import Calendar from '@event-calendar/core';
import TimeGrid from '@event-calendar/time-grid';
import Pet from '@/partial/Pet.vue'
import SelectService from '@/partial/SelectService.vue'
import SelectCustomer from '@/partial/SelectCustomer.vue'
import SelectPet from '@/partial/SelectPet.vue'

export default {
    name: 'Appointments',
    components: {
        Pet,
        SelectService,
        SelectCustomer,
        SelectPet
    },
    data: function(){
        return {
            ec: null, //eventcalendar object
            days: [],
            services: [],
            customers: [],
            appointments: [],
            newAppointment:{
                fromDate: null,
                fromTime: null,
                service: null,
                customer: null,
                pet: null,
                title: "",
                addVisit: false,
                addAsiloOut: false,
                addToelettatura: false,
                addFromDate: null,
                addFromTime: null,
                addPensioneOut: false
            },
            selectedAppointment:{
                fromDate: null,
                fromTime: null,
                serviceId: null,
                customerId: null,
                petId: null,
                title: ""
            },
            showChangeAppointmentDate: false,
            appointmentNewDate: null,
            appointmentNewTime: null,
            appointmentNewDatetime: null,
            showCreationDialog:false,
            showDeletedToast: false,
            showInfoDialog: false,
            isLoading: true,
            isDesktop:true
        };
    },
    async mounted(){
        let vm = this;
        for (let i = 1; i < 8; ++i) {
            let day = new Date();
            let diff = i - day.getDay();
            day.setDate(day.getDate() + diff);
            vm.days[i] = day.getFullYear() + "-" + vm._pad(day.getMonth()+1) + "-" + vm._pad(day.getDate());
        }
        await vm.getCustomers();
        await vm.getServices();
        await vm.initCalendar();
        vm.isLoading=false;
        
    },
    methods:{
        computeNewDatetime(oldStart){
            let vm = this;
            vm.appointmentNewDatetime=oldStart;
            vm.appointmentNewDate=oldStart.toISOString().split('T')[0];
            vm.appointmentNewTime=(oldStart.getHours()<10?"0"+oldStart.getHours():oldStart.getHours())+":"+(oldStart.getMinutes()<10?"0"+oldStart.getMinutes():oldStart.getMinutes());
        },
        _pad(num) {
            let norm = Math.floor(Math.abs(num));
            return (norm < 10 ? '0' : '') + norm;
        },
        async initCalendar(){
            let vm = this;
            await vm.getAppointments();
            try{
                vm.ec.destroy();
            }
            catch(e){
                console.log(e);
            }
            vm.ec = new Calendar({
                target: document.getElementById('ec'),
                props: {
                    plugins: [TimeGrid],
                    options: {
                        events: vm.drawAppointments(),
                        selectable: true,
                        nowIndicator: true,
                        slotMinTime: "07:00:00",
                        slotMaxTime: "20:00:00",
                        slotDuration:"00:05:00",
                        views: {
                            timeGridWeek: {pointer: false}
                        },
                        firstDay: 1,
                        eventClick: function(info){
                            vm.selectedAppointment = vm.appointments.filter(a => a.resourceId == info.event.resourceIds[0])[0];
                            vm.showInfoDialog=true;
                        }
                    }
                }
            });
        },
        drawAppointments() {
            let vm = this;
            let backgrounds = [];
            for (let i = 1; i < 8; ++i) {
                backgrounds.push(
                    {start: vm.days[i] + " 00:00", end: vm.days[i] + " 09:00", resourceId: 1, display: "background"}, 
                    {start: vm.days[i] + " 18:00", end: vm.days[i] + " 23:59", resourceId: 1, display: "background"}
                );
            }
            return vm.appointments.concat(backgrounds);
        },
        async getCustomers(){
            let vm = this;
            try {
                const response = await axios({
                    method: "GET",
                    url: vm.$API_BASE_URL + "getCustomers.php",
                    headers: {
                        'Authentication-Token': window.localStorage.getItem("sogno_at")
                    }
                });
                if (response.status == 200) {
                    vm.customers = [];
                    vm.customers = response.data.resources;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            } catch(error) {
                if(error.response && (error.response.status==403||error.response.status==401)){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            }
        },
        async getServices(){
            let vm = this;
            try {
                const response = await axios({
                    method: "GET",
                    url: vm.$API_BASE_URL + "getServices.php",
                    headers: {
                        'Authentication-Token': window.localStorage.getItem("sogno_at")
                    }
                });
                if (response.status == 200) {
                    vm.services = [];
                    vm.services = response.data.resources;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            } catch(error) {
                if(error.response && (error.response.status==403||error.response.status==401)){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            }
        },
        async getAppointments(){
            let vm = this;
            try {
                const response = await axios({
                    method: "GET",
                    url: vm.$API_BASE_URL + "getAppointments.php",
                    headers: {
                        'Authentication-Token': window.localStorage.getItem("sogno_at")
                    }
                });
                if (response.status == 200) {
                    vm.appointments = [];
                    response.data.resources.forEach(function(appointment){
                        vm.appointments.push({
                            start: new Date(appointment.from),
                            end: new Date(appointment.to),
                            resourceId: appointment.id,
                            customerId: appointment.customerId,
                            petId: appointment.petId,
                            title: appointment.title,
                            color: appointment.color            
                        });
                    });
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            } catch(error) {
                if(error.response && (error.response.status==403||error.response.status==401)){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            }
        },
        createAppointment(serviceId, customerId, fromDate, fromTime){
            let vm = this;
            if(!serviceId || !customerId || !fromDate || !fromTime){
                alert("Verificare di aver inserito tutti i dati richiesti!");
                return;
            }
            var selectedService = vm.services.filter(s=>s.id == serviceId)[0];
            var a = selectedService.time.split(':');
            var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]); //service duration in seconds
            var offset = (new Date()).getTimezoneOffset();
            var appointmentTo = (new Date(fromDate  + "T" + fromTime));
            appointmentTo = new Date(appointmentTo.getTime() + offset*60000);
            var appointmentFrom = new Date(appointmentTo.getTime());
            appointmentTo.setSeconds(appointmentTo.getSeconds() + seconds);
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "createAppointment.php",
                data: {
                    customerId: customerId,
                    serviceId: serviceId,
                    petId: vm.newAppointment.pet,
                    title: selectedService.category + " > " + selectedService.name + " " + vm.newAppointment.title,
                    appointmentFrom: appointmentFrom,
                    appointmentTo: appointmentTo
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status !== 200) {
                    alert("Si è verificato un errore durante il caricamento");
                }
                else{
                    //Toelettatura + visita
                    if(vm.newAppointment.addVisit){
                        vm.newAppointment.addVisit=false;
                        let newFromDate = appointmentTo.getFullYear()+"-"+(appointmentTo.getMonth()<9?"0":"")+(appointmentTo.getMonth()+1)+"-"+(appointmentTo.getDate()<10?"0":"")+appointmentTo.getDate();
                        let newFromTime = (appointmentTo.getHours()<10?"0":"")+appointmentTo.getHours()+":"+(appointmentTo.getMinutes()<10?"0":"")+appointmentTo.getMinutes();
                        vm.createAppointment(17, customerId, newFromDate, newFromTime);
                        return;
                    }
                    if(vm.newAppointment.addAsiloOut||vm.newAppointment.addToelettatura||vm.newAppointment.addPensioneOut){
                        //Pensione ingresso + pensione uscita + toelettatura
                        if(vm.newAppointment.addPensioneOut&&vm.newAppointment.addToelettatura){
                            vm.newAppointment.addPensioneOut=false;
                            vm.newAppointment.addToelettatura=false;
                            vm.createAppointment(9, customerId, vm.newAppointment.addFromDate, vm.newAppointment.addFromTime);

                            var newSelectedService = vm.services.filter(s=>s.id == 12)[0];
                            var a = newSelectedService.time.split(':');
                            var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]); //service duration in seconds
                            var newAppointmentTo = new Date(vm.newAppointment.addFromDate  + "T" + vm.newAppointment.addFromTime);
                            newAppointmentTo.setSeconds(newAppointmentTo.getSeconds() - seconds); //placing bagno before the end service start

                            let newFromDate = newAppointmentTo.getFullYear()+"-"+(newAppointmentTo.getMonth()<9?"0":"")+(newAppointmentTo.getMonth()+1)+"-"+(newAppointmentTo.getDate()<10?"0":"")+newAppointmentTo.getDate();
                            let newFromTime = (newAppointmentTo.getHours()<10?"0":"")+newAppointmentTo.getHours()+":"+(newAppointmentTo.getMinutes()<10?"0":"")+newAppointmentTo.getMinutes();
                            vm.createAppointment(12, customerId, newFromDate, newFromTime);
                            return;
                        }

                        //Asilo ingresso + asilo uscita + toelettatura
                        if(vm.newAppointment.addAsiloOut&&vm.newAppointment.addToelettatura){
                            vm.newAppointment.addAsiloOut=false;
                            vm.newAppointment.addToelettatura=false;
                            vm.createAppointment(19, customerId, vm.newAppointment.addFromDate, vm.newAppointment.addFromTime);                            
                            
                            var newSelectedService = vm.services.filter(s=>s.id == 12)[0];
                            var a = newSelectedService.time.split(':');
                            var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]); //service duration in seconds
                            var newAppointmentTo = new Date(vm.newAppointment.addFromDate  + "T" + vm.newAppointment.addFromTime);
                            newAppointmentTo.setSeconds(newAppointmentTo.getSeconds() - seconds);

                            let newFromDate = newAppointmentTo.getFullYear()+"-"+(newAppointmentTo.getMonth()<9?"0":"")+(newAppointmentTo.getMonth()+1)+"-"+(newAppointmentTo.getDate()<10?"0":"")+newAppointmentTo.getDate();
                            let newFromTime = (newAppointmentTo.getHours()<10?"0":"")+newAppointmentTo.getHours()+":"+(newAppointmentTo.getMinutes()<10?"0":"")+newAppointmentTo.getMinutes();
                            vm.createAppointment(12, customerId, newFromDate, newFromTime);
                            return;
                        }
                        //Asilo ingresso + asilo uscita
                        if(vm.newAppointment.addAsiloOut){
                            vm.newAppointment.addAsiloOut=false;
                            vm.createAppointment(19, customerId, vm.newAppointment.addFromDate, vm.newAppointment.addFromTime);
                            return;
                        }
                        //Pensione ingresso + pensione uscita 
                        if(vm.newAppointment.addPensioneOut){
                            vm.newAppointment.addPensioneOut=false;
                            vm.createAppointment(9, customerId, vm.newAppointment.addFromDate, vm.newAppointment.addFromTime);
                            return;
                        }
                        //Solo toelettatura in uscita
                        if(vm.newAppointment.addToelettatura){
                            vm.newAppointment.addToelettatura=false;
                            vm.createAppointment(12, customerId, vm.newAppointment.addFromDate, vm.newAppointment.addFromTime);
                            return;
                        }
                    }                    
                    vm.initCalendar();   
                }
            })
            .catch(function (error) {
                if(error.response && (error.response.status==403||error.response.status==401)){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        },
        saveNewDate(appointmentId, fromDate, fromTime){
            let vm = this;
            if(!appointmentId || !fromDate || !fromTime){
                alert("Verificare di aver inserito tutti i dati richiesti!");
                return;
            }
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "editAppointmentDates.php",
                data: {
                    id: appointmentId,
                    newStart: vm.computedNewStart,
                    newEnd: vm.computedNewEnd
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status !== 200) {
                    alert("Si è verificato un errore durante il caricamento");
                }
                else{    
                    vm.initCalendar();   
                }
            })
            .catch(function (error) {
                if(error.response && (error.response.status==403||error.response.status==401)){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        },
        deleteAppointment(appointmentId){
            let vm = this;
            axios({
                method: "DELETE",
                url: vm.$API_BASE_URL + "deleteAppointment.php",
                data: {
                    "appointmentId":appointmentId
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.showDeletedToast = true;
                    vm.initCalendar();   
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        }
    },
    computed:{
        selectedAppointmentCustomer(){
            let vm = this;
            return vm.customers.filter(c=>c.id == vm.selectedAppointment.customerId)[0];
        },
        computedNewEnd(){
            let vm = this;
            let duration = (new Date(vm.selectedAppointment.end)-new Date(vm.selectedAppointment.start));
            var appointmentTo = (new Date(vm.appointmentNewDate  + "T" + vm.appointmentNewTime));
            appointmentTo = new Date(appointmentTo.getTime() + duration);
            return appointmentTo.toISOString();
        },
        computedNewStart(){
            let vm = this;
            var appointmentTo = (new Date(vm.appointmentNewDate  + "T" + vm.appointmentNewTime));
            appointmentTo = new Date(appointmentTo.getTime());
            return appointmentTo.toISOString();
        },
        shownListAppointments(){
            let vm = this;
            return vm.appointments.filter(a=>(new Date(a.start))>(new Date()));
        }
    }
}
</script>

<style scoped>
.container{
    max-width:100%!important;
}
</style>
